module.exports = __webpack_public_path__ + "img/razzo5.b6b1d562.png";